import { CommonModule } from '@angular/common';
import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { FooterHeaderComponent } from '../footer-header/footer-header.component';
import { FooterComponent } from "../footer/footer.component";

@Component({
  selector: 'app-accessibility-guidance',
  standalone: true,
  imports: [CommonModule, FooterHeaderComponent, FooterComponent],
  templateUrl: './accessibility-guidance.component.html',
  styleUrl: './accessibility-guidance.component.scss'
})
export class AccessibilityGuidanceComponent implements OnInit {
  isStandalonePage: boolean = false;
  showContactBot: boolean = false;
  showCopyMessage: boolean = false;
  copyMessageText: string = '';

  constructor(private router: Router) {
    this.isStandalonePage = !this.router.url.startsWith('/home');
  }

  ngOnInit() {
    // Initialize animations
    this.initializeAnimations();
    
    // Wait for 5 seconds and then show the contact bot
    setTimeout(() => {
      this.showContactBot = true;
    }, 6000); // 5000 milliseconds = 5 seconds
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.checkScrollAnimations();
  }

  closeContactBot() {
    this.showContactBot = false;
  }

  openContactBot() {
    this.showContactBot = true;
  }

  copyEmail() {
    const email = 'support@hpslife.com';
    navigator.clipboard.writeText(email).then(() => {
      this.showCopyNotification('Email copied!');
    }).catch(err => {
      console.error('Failed to copy email:', err);
    });
  }

  copyPhone() {
    const phone = '+44 (0) 123 456 7890';
    navigator.clipboard.writeText(phone).then(() => {
      this.showCopyNotification('Phone copied!');
    }).catch(err => {
      console.error('Failed to copy phone:', err);
    });
  }

  private showCopyNotification(message: string) {
    this.copyMessageText = message;
    this.showCopyMessage = true;

    // Hide the message after 2 seconds
    setTimeout(() => {
      this.showCopyMessage = false;
    }, 2000);
  }

  private initializeAnimations() {
    // Initialize intersection observer for animations
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
        }
      });
    }, {
      threshold: 0.3,
      rootMargin: '0px 0px -50px 0px'
    });

    // Observe elements for animation
    setTimeout(() => {
      const elements = document.querySelectorAll(`
        .access-heading, 
        .feature-item, 
        .feature-icon, 
        .feature-text,
        .section-header-modern,
        .modern-section-title,
        .title-underline,
        .modern-section-description,
        .modern-cards-container,
        .modern-card,
        .card-header,
        .card-icon,
        .card-title,
        .card-content,
        .platform-section,
        .browser-section,
        .tools-grid,
        .tool-card,
        .tool-header,
        .tool-icon,
        .tool-card h3,
        .problems-container,
        .problem-card,
        .problem-icon,
        .problem-card h3,
        .problem-card p
      `);
      
      elements.forEach(element => {
        observer.observe(element);
      });
    }, 200);
  }

  private checkScrollAnimations() {
    const sections = document.querySelectorAll('.section-header-modern');
    sections.forEach(section => {
      const rect = section.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      
      if (rect.top < windowHeight * 0.8 && rect.bottom > windowHeight * 0.2) {
        section.classList.add('animate-in');
      }
    });
  }
}
